<div class="signout-redirect">
  <h2>You have been signed out</h2>
  <p>Click the button below to return to the sign in page.</p>
  <lib-button
    styleName="button--primary"
    buttonText="Go to Sign In Page"
    (clickEvent)="navigateToHomepage()"
    [attr.data-qa-id]="'sign-in-page-button'"
  ></lib-button>
</div>
